import { Dropdown, DropdownItemProps, DropdownItem, DropdownProps } from "@heroui/react"

// 对nextui的Drapdown进行了一些样式修改
export const SelfDropdown = ({ children, ...reset }: DropdownProps) => {
  return <Dropdown
    classNames={{
      content: "min-w-[148px] w-[148px] bg-gray-bg p-0 shadow-md",
      base: "p-0",
    }}
    placement="right-start"
    offset={20}
    crossOffset={-20}
    {...reset}
  >
    {children}
  </Dropdown>
}

export const SelfDropdownItem = ({ children, ...reset }: DropdownItemProps) => {
  return (
    <DropdownItem
      {...reset}
    >
      <div className="flex items-center gap-[8px] w-[140px]">
        {children}
      </div>
    </DropdownItem>
  )
}